
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLanguage } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import AboutSection from '@/components/AboutSection';

const About = () => {
  const { language } = useLanguage();
  
  const pageTitle = language === 'en' ? 'About | Attaboy Intelligence' : 'À Propos | Attaboy Intelligence Artificielle';
  const pageDescription = language === 'en' 
    ? 'Learn about our mission to make AI radically accessible for businesses of all sizes.' 
    : 'Découvrez notre mission de rendre l\'IA radicalement accessible aux entreprises de toutes tailles.';

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
      </Helmet>
      
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="pt-24">
          <div className="container mx-auto px-4 py-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 font-poppins">
              {language === 'en' ? 'About Us' : 'À Propos de Nous'}
            </h1>
          </div>
          <AboutSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default About;
